export default "__VITE_PUBLIC_ASSET__7e5609c8__"